import React from 'react';

import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';
import { ImplicitAuthFormDictionary } from 'types/i18n';
import { originSiteMap } from 'utils/constants';
import { routes } from 'utils/routes';
import { ParagraphComponent } from 'design/paragraph';

const defaultAgreementTextIntl = () => (
  <TextComponent>
    Продолжая регистрацию, вы подтверждаете, что принимаете{' '}
    <LinkControlComponent to={originSiteMap.TERMS_URL} newTab>
      <TextComponent color="accent" animatedColor>
        Пользовательское соглашение
      </TextComponent>
    </LinkControlComponent>{' '}
    и{' '}
    <LinkControlComponent to={originSiteMap.PRIVACY_URL} newTab>
      <TextComponent color="accent" animatedColor>
        Политику конфиденциальности
      </TextComponent>
    </LinkControlComponent>
    .
  </TextComponent>
);

const demoAgreementTextIntl = () => (
  <TextComponent>
    <ParagraphComponent>
      Демоверсия — это реальная программа, которая для примера заполнена
      информацией. Вы можете совершать любые действия с данными, они будут
      сохраняться.
    </ParagraphComponent>
    <ParagraphComponent>
      Срок демонстрации вашей демоверсии — 7 дней. Если вы захотите вернуться к
      демоверсии позже этого срока — создайте ее заново.
    </ParagraphComponent>
    <ParagraphComponent>
      Создавая демоверсию, вы подтверждаете, что принимаете{' '}
      <LinkControlComponent to={originSiteMap.TERMS_URL} newTab>
        <TextComponent color="accent" animatedColor>
          Пользовательское соглашение
        </TextComponent>
      </LinkControlComponent>{' '}
      и{' '}
      <LinkControlComponent to={originSiteMap.PRIVACY_URL} newTab>
        <TextComponent color="accent" animatedColor>
          Политику конфиденциальности
        </TextComponent>
      </LinkControlComponent>
      .
    </ParagraphComponent>
  </TextComponent>
);

const emailAlreadyInUseTextIntl = () => (
  <TextComponent>
    Партнер с таким email уже существует. Пожалуйста, укажите ваш email и пароль
    на{' '}
    <LinkControlComponent to="/">
      <TextComponent color="accent" animatedColor>
        странице авторизации
      </TextComponent>
    </LinkControlComponent>
    . Или пройдите процедуру{' '}
    <LinkControlComponent to={routes.restorePassword()}>
      <TextComponent color="accent" animatedColor>
        восстановления пароля
      </TextComponent>
    </LinkControlComponent>
    .
  </TextComponent>
);

export const implicitAuthFormDictionaryRu: ImplicitAuthFormDictionary = {
  demoTitleText: 'Демоверсия',
  prodTitleText: 'Создание аккаунта',
  partnerTitleText: 'Создание аккаунта',
  mainTitleText: 'Личный кабинет',
  demoDetailsText:
    'Вы сможете «потрогать» и изучить каждый раздел программы AGM. Добавляйте, меняйте и удаляйте любые данные — демоверсия только для вас.',
  demoAgreementText: demoAgreementTextIntl,
  prodAgreementText: defaultAgreementTextIntl,
  partnerAgreementText: defaultAgreementTextIntl,

  emailAlreadyInUseText: emailAlreadyInUseTextIntl,
  codeLabel: 'Введите код, который вы получили на email:',
  codeInvalidLabel: 'Некорректный код, попробуйте еще раз:',
  submitEmailFormActionText: 'Продолжить',
  submitConfirmationFormActionText: 'Войти',
  changeEmailActionText: 'изменить',
  selectEmailProviderActionText: 'Использовать email',
  delimiterText: 'или',
  restorePasswordText: 'Забыли пароль?',
  restorePasswordLinkText: 'Восстановить',
};
